'use client';

import { useStore } from 'zustand';
import { useRouter } from 'next/navigation';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { authStore } from '@/store/auth.store';
import { setOpenSignInModal } from '@/store/modal';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { useFeatureFlagContext } from '@/store/feature-flag.store';
import { config } from '@/config/config';
import { useAgendamentoNavigation } from '@/hooks/navigation/use-agendamento-navigation.hook';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';

export const FaqLoginButton = () => {
  const { buildLink: buildAgendamentoLink } = useAgendamentoNavigation();
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const enableAuth = useStore(
    useFeatureFlagContext,
    (state) => state.enableAuth,
  );

  const { buttonSmFit } = styleFaq();
  const router = useRouter();
  const agendamentoAppHref = buildAgendamentoLink({ path: '/agendamentos' });

  function onClickWhenNotLoggedIn() {
    setOpenSignInModal(true, () => {
      router.push('/agendamentos/');
      const logger = getAnalyticsPlugin();
      logger.track(AnalyticsEnum.REDIRECT_FAQ_TO_APPOINTMENT_AFTER_LOGIN);
    });
  }

  if (!enableAuth) {
    return null;
  }

  if (config.stageOneEnabled) {
    return (
      <Button variant="secondary" className={buttonSmFit({ className: 'px-12' })} asChild>
        <Link
          prefetch={false}
          href={agendamentoAppHref}
          data-analytics-event={AnalyticsEnum.CLICK_FAQ_MY_ONLINE_SIGN_IN_BUTTON}
        >
          Meu cadastro online
        </Link>
      </Button>
    );
  }

  if (isLoggedIn) {
    return (
      <Button variant="secondary" className={buttonSmFit({ className: 'px-12' })} asChild>
        <Link
          prefetch={false}
          href="/agendamentos/"
          data-analytics-event={AnalyticsEnum.CLICK_FAQ_MY_ONLINE_SIGN_IN_BUTTON}
        >
          Meu cadastro online
        </Link>
      </Button>
    );
  }

  return (
    <Button
      variant="secondary"
      className={buttonSmFit({ className: 'px-12' })}
      onClick={onClickWhenNotLoggedIn}
      data-analytics-event={AnalyticsEnum.CLICK_FAQ_MY_ONLINE_SIGN_IN_BUTTON}
    >
      Meu cadastro online
    </Button>
  );
};
